export default {
  toolbar: {
    flex: 1,
    alignItems: 'flex-end',
  },
};
